import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ClientPicker.';
  public static readonly selectClient = `${Id.prefix}selectClient`;
  public static readonly close = `${Id.prefix}close`;
}

export class LangClientPicker {
  private constructor() {}
  public static selectClient(): string {
    return interpolate(Id.selectClient);
  }
  public static close(): string {
    return interpolate(Id.close);
  }
}

export class ClientPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.selectClient, "Select a {{glossary 'client'}}", 'Dialog title for selecting a client');
    register.add(Id.close, 'Close', 'Button label for closing the dialog');
  }
}
